import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import PayrollList, { DispatchProps, OwnProps, StateProps } from './PayrollList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getPayrolls } from 'src/store/actions/payroll-actions';
import { getPayrollsCsv } from 'src/store/actions/payroll-actions';
import { getPayrollsInFile } from 'src/store/actions/payroll-actions';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.payrolls.data,
        inProgress: state.payrolls.inProgress,
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getDataCsv: (params: QueryParams) => dispatch(getPayrollsCsv(params)),
        getDataInFile: (params: QueryParams) => dispatch(getPayrollsInFile(params)),
        getData: (params: QueryParams) => dispatch(getPayrolls(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
    };
}

const PayrollListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(PayrollList);

export default PayrollListScreen;
